const resources = {
    ctaApply: 'Apply',
    ctaApplied: 'Applied',
    ctaRemove: 'Remove',
    ctaUrl: 'Shop Now',
    ctaAppOnly: 'App Exclusive',
    ctaStoreOnly: 'In Store Only',
    seeDetails: 'See details',
    insider: 'Beauty Insider members only.',
    vib: 'Rouge & VIB only.',
    rouge: 'Rouge members only.',
    ends: 'Ends',
    starts: 'Starts',
    appOnly: 'App only',
    onlineOnly: 'Online only',
    storeOnly: 'In store only',
    inStoreOrOnline: 'In store & online',
    daysLeft: 'Days Left',
    dayLeft: 'Day Left',
    lastDay: 'Last Day',
    comingSoon: 'Coming Soon',
    viewAll: 'View all',
    ctaAppOnlyAriaLabel: 'This offer is exclusively available on the Sephora app',
    ctaStoreOnlyAriaLabel: 'This offer is available in store only'
};

export default function getResource(label) {
    return resources[label];
}
